module.exports = __webpack_public_path__ + "static/sales-cea433d6d265ffe2685b34657e319ea1.jpg";